import type { ActorRefFrom } from "xstate";
import type {
  transferArtworkMachine,
  TransferSizesFormControl
} from "@design-lab/entities/transfers-lab/model/transfer-artwork.machine";
import { TransfersFormWrapper } from "./TransfersFormWrapper";

type TransfersSizesContentProps = {
  items: Array<{ id: string }>;
  selectedArtwork: ActorRefFrom<typeof transferArtworkMachine> | null | undefined;
  artworkId: string | null;
  isInitialized: boolean;
  sizesFormControl: TransferSizesFormControl | undefined;
  onUpload: () => void;
  onAddTransferType: () => void;
  enhancementTier: string;
};

export function TransfersSizesContent({
  items,
  selectedArtwork,
  artworkId,
  isInitialized,
  sizesFormControl,
  onUpload,
  onAddTransferType,
  enhancementTier
}: TransfersSizesContentProps) {
  // Check if we have artworks but none selected
  if (items.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="text-sm text-gray-500">No artworks uploaded yet</p>
        <button
          type="button"
          onClick={onUpload}
          className="mt-4 text-sm text-blue-600 hover:text-blue-700"
          data-testid="upload-first-artwork"
        >
          Upload your first artwork
        </button>
      </div>
    );
  }

  // Check if artwork is still being processed/initialized
  if (!selectedArtwork || !artworkId || !isInitialized || !sizesFormControl) {
    return (
      <div className="flex items-center justify-center py-12">
        <p className="text-sm text-gray-500">Loading artwork details...</p>
      </div>
    );
  }

  // Render the form wrapper when everything is ready
  // The wrapper handles lens creation safely
  return (
    <TransfersFormWrapper
      artworkId={artworkId}
      sizesFormControl={sizesFormControl}
      onAddTransferType={onAddTransferType}
      enhancementTier={enhancementTier}
      artworkActor={selectedArtwork}
    />
  );
}
